import React from "react";
import axios from "axios";
import {
	Button,
	Card,
	Modal,
	Col,
	Form,
	Icon,
	Input,
	Collapse,
	Row,
	Spin,
	message,
	Switch,
	Cascader,
	Upload,
	notification,
} from "antd";
import { connect } from "react-redux";
import { decode } from "utf8";
import { fetchProduct, createProduct } from "appRedux/actions/Product";
const Panel = Collapse.Panel;
const FormItem = Form.Item;
const { TextArea } = Input;
const AUTH_TOKEN =
	"eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJoZWFkZXIiOnsiaWQiOiIwIiwidXNlciI6Ik1hbnVlbEdpbCJ9LCJwYXlsb2FkIjp7ImlhdCI6IjIwMTktMDEtMDEgMDA6MDA6MDAiLCJleHAiOiIyMDIwLTAxLTAxIDAwOjAwOjAwIn19.p_PtmXsDe3l_osPEzb4edkf-M2SCdUVBQBKs8ZAbpn8";

function handleStatusVideo(file) {
	this.state({ videoUrl: file });
}

class Basic extends React.Component {
	state = {
		visible: false,
		id: "",
		description: "",
		status: "",
		price: "",
		name: "",
		videoUrl: "",
		validateId: "",
		validateDescription: "",
		validateStatus: "",
		validatePrice: "",
		validateName: "",
		statusResponse: "",

		helpId: "",
		helpDescription: "",
		helpName: "",
		helpStatus: "",
		helpPrice: "",
	};

	componentDidMount() {
		this.props.fetchProduct();
	}

	showModal = () => {
		this.setState({
			visible: true,
		});
	};

	handlChangeVideo = (selectorFiles) => {
		const file = selectorFiles[0];
		this.setState({ videoUrl: file });
		console.log("file", file);
	};
	handlChangeVideoANTD = (files) => {
		const file = files;
		this.setState({ videoUrl: file });
		console.log("file", file);
	};

	handleCancel = (e) => {
		this.setState({
			id: "",
			name: "",
			description: "",
			status: "",
			price: "",
			videoUrl: "",
			statusResponse: 1,
		});

		this.props.fetchProduct();
		this.setState({ visible: false });

		if (this.state.id == "") {
			this.setState({ validateId: "", helpId: "" });
		}
		if (this.state.name == "") {
			this.setState({ validateName: "", helpName: "" });
		}
		if (this.state.description == "") {
			this.setState({ validateDescription: "", helpDescription: "" });
		}
		if (this.state.price == "") {
			this.setState({ validatePrice: "", helpPrice: "" });
		}
	};

	onChangeS = (checked) => {
		if (checked) {
			this.setState({ status: 1 });
		} else {
			this.setState({ status: 0 });
		}
	};

	onNotification = (type, value) => {
		if (type == "success") {
			notification[type]({
				message: "Éxito",
				description: "El producto se ha creado con éxito.",
			});
		} else {
			notification[type]({
				message: "Error",
				description: value || "Ha ocurrido un error al crear el producto.",
			});
		}
		if (type == "info") {
			notification[type]({
				message: "Éxito",
				description: "El producto se esta cargando.",
			});
		}
	};

	handleChangeVideo = (info) => {
		if (info.file.status !== "uploading") {
			console.log(info.file, info.fileList);
		}
		if (info.file.status === "done") {
			this.setState({ videoUrl: info.file.originFileObj });
			message.success(`${info.file.name} video cargado correctamente`);
			console.log("state", this.state);
		} else if (info.file.status === "error") {
			message.error(`${info.file.name} error al cargar el video`);
		}
	};

	createTest = async (name, description, price, videoUrl) => {
		const formData = new FormData();
		formData.append("name", name);
		formData.append("description", description);
		formData.append("price", price);
		formData.append("file", videoUrl);

		const response = await axios({
			method: "post",
			url: `https://admingreenerapp.crsostenible.com/api/public/api/app/product/add`,
			data: formData,
			headers: {
				"Content-Type": "application/json",
				Authorization: "Bearer " + AUTH_TOKEN,
			},
		})
			.then((response) => {
				if (response.data.status == 1) {
					this.props.fetchProduct(this.state);

					this.setState({
						id: "",
						name: "",
						description: "",
						price: "",
						status: 1,
						videoUrl: "",
						statusResponse: 0,
					});

					this.onNotification("success");
				} else {
					if (response == "") {
						this.onNotification("info");
					}
				}
			})

			.catch((error) => alert(error.message));
	};

	onHandleClick = (event) => {
		event.preventDefault();
		this.setState({
			statusResponse: 2,
		});
		console.log(this.state.statusResponse);
		let { description, price, name, videoUrl } = this.state;
		if (this.state.validateStatus != "error") {
			if (description && price && name != "" && videoUrl != "") {
				//this.createTest(name,description,price,videoUrl)
				let res = this.props.createProduct(this.state, () => {
					this.props.fetchProduct(this.state);
				});
			} else {
				if (this.state.id == "") {
					this.setState({
						validateId: "error",
						helpId: "Id del producto es un campo obligatorio.",
					});
				} else {
					this.setState({ validateId: "", helpId: "" });
				}
				if (this.state.name == "") {
					this.setState({
						validateName: "error",
						helpName: "Nombre es un campo obligatorio.",
					});
				} else {
					this.setState({ validateName: "", helpName: "" });
				}
				if (this.state.description == "") {
					this.setState({
						validateDescription: "error",
						helpDescription:
							"Descripción del producto es un campo obligatorio.",
					});
				} else {
					this.setState({ validateDescription: "", helpDescription: "" });
				}
				if (this.state.price == "") {
					this.setState({
						validatePrice: "error",
						helpPrice: "Precio es un campo obligatorio.",
					});
				} else {
					this.setState({ validatePrice: "", helpPrice: "" });
				}
			}
		} else {
			console.log("error validate status");
		}
	};

	render() {
		let labelActionStatus;

		const statusResponse = this.state.statusResponse;
		if (statusResponse == 2) {
			labelActionStatus = (
				<Spin className="gx-loader-container" tip="Añadiendo nuevo producto" />
			);
		} else {
			if (statusResponse == 0) {
				labelActionStatus = "";
			}
		}
		const { Dragger } = Upload;
		const props = {
			name: "file",
			action: "https://www.mocky.io/v2/5cc8019d300000980a055e76",
			headers: {
				authorization: "authorization-text",
			},
		};
		return (
			<div>
				<Button type="primary" onClick={this.showModal}>
					Crear producto
				</Button>
				<Modal
					afterClose={() => this.props.fetchProduct()}
					okText="Crear"
					cancelText="Salir"
					title=""
					visible={this.state.visible}
					onOk={this.onHandleClick}
					onCancel={this.handleCancel}
				>
					<Card className="gx-card" title="Nuevo producto">
						<form onSubmit={this.onHandleClick}>
							<Row className="padding-modal">
								<Col lg={5} md={5} sm={5} xs={5}>
									<FormItem
										label="Nombre"
										validateStatus={this.state.validateName}
										help={this.state.helpName}
									></FormItem>
								</Col>
								<Col lg={19} md={19} sm={19} xs={19}>
									<Input
										required
										placeholder="Nombre del producto"
										value={this.state.name}
										onChange={(event) => {
											this.setState({
												name: event.target.value,
											});
											if (event.target.value != "") {
												this.setState({
													validateName: "",
													helpName: "",
												});
											} else {
												this.setState({
													validateName: "error",
													helpName: "Nombre es un campo obligatorio.",
												});
											}
										}}
									/>
								</Col>

								<Col lg={5} md={5} sm={5} xs={5}>
									<FormItem
										label="Precio"
										validateStatus={this.state.validatePrice}
										help={this.state.helpPrice}
									></FormItem>
								</Col>
								<Col lg={19} md={19} sm={19} xs={19}>
									<Input
										required
										placeholder="Precio del producto"
										value={this.state.price}
										onChange={(event) => {
											this.setState({
												price: event.target.value,
											});
											if (event.target.value != "") {
												this.setState({
													validatePrice: "",
													helpPrice: "",
												});
											} else {
												this.setState({
													validatePrice: "error",
													helpPrice: "Precio es un campo obligatorio.",
												});
											}
										}}
									/>
								</Col>

								<Col lg={19} md={19} sm={19} xs={19}>
									<FormItem
										label="Descripción"
										validateStatus={this.state.validateDescription}
										help={this.state.helpDescription}
									></FormItem>
								</Col>
								<Col lg={19} md={19} sm={19} xs={19}>
									<TextArea
										rows={4}
										required
										placeholder="Descripción del producto"
										value={this.state.description}
										onChange={(event) => {
											this.setState({
												description: event.target.value,
											});
											if (event.target.value != "") {
												this.setState({
													validateDescription: "",
													helpDescription: "",
												});
											} else {
												this.setState({
													validateDescription: "error",
													helpDescription: "Nombre es un campo obligatorio.",
												});
											}
										}}
									/>
								</Col>

								<Col lg={24} md={24} sm={24} xs={24}>
									<FormItem label="Video">
										<Dragger {...props} onChange={this.handleChangeVideo}>
											<p className="ant-upload-drag-icon"></p>
											<p className="ant-upload-text">
												Haga click o arrastre el video en formato mp4 a esta
												área para cargar
											</p>
										</Dragger>
									</FormItem>
								</Col>
							</Row>
						</form>
					</Card>
					{labelActionStatus}
				</Modal>
			</div>
		);
	}
}

function mapStateToProps({ placeStores, products }) {
	return {
		placeStores,
		products,
	};
}
export default connect(mapStateToProps, { fetchProduct, createProduct })(Basic);



// WEBPACK FOOTER //
// ./src/routes/main/Products/Modal.js